export default {"src":"/_next/static/media/RedDeleteButton.8cd3c5ea.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};